import { render, staticRenderFns } from "./UserResetPassword.vue?vue&type=template&id=2e83500d&scoped=true&"
import script from "./UserResetPassword.vue?vue&type=script&lang=js&"
export * from "./UserResetPassword.vue?vue&type=script&lang=js&"
import style0 from "./UserResetPassword.vue?vue&type=style&index=0&id=2e83500d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e83500d",
  null
  
)

export default component.exports